export default "__VITE_ASSET__7_BW2VoB__"